// Shared trust badges shown under the auth forms (Login / Register).
const ICON_PROPS = {
	viewBox: '0 0 24 24',
	fill: 'none',
	stroke: 'currentColor',
	strokeWidth: 2,
	strokeLinecap: 'round',
	strokeLinejoin: 'round',
	className: 'w-3.5 h-3.5',
};

const ITEMS = [
	{
		label: 'SSL Secured',
		icon: (
			<svg {...ICON_PROPS}>
				<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
				<path d="m9 12 2 2 4-4"/>
			</svg>
		),
	},
	{
		label: 'Multiple languages',
		icon: (
			<svg {...ICON_PROPS}>
				<circle cx="12" cy="12" r="10"/>
				<path d="M2 12h20"/>
				<path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
			</svg>
		),
	},
	{
		label: 'AI voices',
		icon: (
			<svg {...ICON_PROPS}>
				<polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
			</svg>
		),
	},
];

export default function TrustRow() {
	return (
		<div className="auth-fade-4 flex items-center justify-center gap-5 mt-8 pt-6 border-t border-slate-100">
			{ITEMS.map((item) => (
				<div key={item.label} className="flex items-center gap-1.5 text-slate-400">
					{item.icon}
					<span className="text-[11px] font-medium">{item.label}</span>
				</div>
			))}
		</div>
	);
}
